import React, {useState, useEffect} from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {Grid, Box, ButtonBase} from '@mui/material';
import {theme} from '../../../themes/default-theme';
import Text from '../../../components/typography';
import Cta from '../../../components/ui/Cta';
import {Links} from '../../../components/ui';
import NextLink from '../../../components/navigation/NextLink';
import {ReactSVG} from 'react-svg';
import Checkbox from '../../../components/forms/Checkbox';
import {useMediaQuery} from '@mui/material';
import chevronDown from '../../../assets/icons/chevron-down.svg';
import filter from '../../../assets/icons/filter-2.svg';
import close from '../../../assets/icons/close.svg';
import Dropdown from '../../../components/ui/Dropdown';

const Wrapper = styled.div`
  width:100%;
  h6 {
    font-size:14px;
    margin-bottom:10px;
  }
  .grid-selector {
    ${theme.breakpoints.down("md")} {
      align-items: flex-start;
    }
    > div {
      ${theme.breakpoints.up("lg")} {
        max-width: 455px;
        text-align: left;
        min-width: 220px;
      }
    }
    gap:25px;
    ${theme.breakpoints.up("lg")} {
      gap:30px;
      &.hidden {
        display:none;
      }
    }
    &--2 {
      margin-top:30px;
    }
  }
  .dropdown-range-filter {
    width:100%;
    max-width:167px;
  }
  .available-text-container {
    ${theme.breakpoints.down("md")} {
      display:none;
    }
  }
  .modal-container {
    ${theme.breakpoints.down("md")} {
      display:none;
      &.show {
        display:block;
      }
    }
  }
`

const Container = styled.div`
  width:100%;
  ${theme.breakpoints.down("md")} {
    position:fixed;
    left:0;
    top:0;
    height:100%;
    background:${theme.palette.white};
    z-index:1299; 
    padding:20px 0;
    overflow: auto;
    text-align: left;
  }
`

const CloseModal = styled.div`
  display:none;
  ${theme.breakpoints.down("md")} {
    display:block;
    position:absolute;
    right:20px;
    top:20px;
    cursor:pointer;
  }
  svg {
    path {
      stroke:#7D7D7D;
    }
  }
`

const SelectItem = styled.div`  
  display:inline-block;
  margin-bottom: 10px;
  button {
    margin-right: 10px;
    border-radius:20px; 
  }

  label {
    display:inline-block;
    padding:8px 15px; 
    border:1px solid #D6D6D6;
    border-radius:20px;    
    margin-left:0;
    margin-right: 0;

    span {
      font-weight:500;
      &:first-child {
        display:none;
      }
    }
    ${props => props.checked && `
      color:${theme.palette.white};
      background:${theme.palette.vividBlue};
      span {
        font-weight:600;
        color:${theme.palette.white};
      }
    `}
  }
`

const AvailableText = styled.div`
  background:${theme.palette.charcoal};
  display:none;
  color:${theme.palette.white};
  border-radius:20px;
  font-weight:600;
  padding:8px 15px; 
  font-size:16px;
  ${theme.breakpoints.up("lg")} {
    display:inline-block;
    margin-top: 29px;
    float: right;
  }
`

const DropdownRangeContainer = styled.div`
  width:167px;
  div {
    width:100%;
    max-width:167px;
  }
`

const ControllerDesktop = styled.div`
  margin-top:20px;
   display:none;
   ${theme.breakpoints.up("lg")} {
    display:block;
   } 
   a {
    font-size:15px;
    font-weight:700;
    text-transform:uppercase;
    text-decoration:none;
    margin-right:40px;
    > div {
      display:inline-block;
      position:relative;
      top:-1px;
      margin-left:3px;
      transition: transform 300ms ease-in-out;
    }

    &.is-active {
      > div {
        transform: rotate(180deg);
        top: 1px;
      }
    }

    svg {      
      g {
        stroke: ${theme.palette.vividBlue} !important;
      }
      
    }
   }
`
const ControllerMobile = styled.div`
  .gird-ctas {
    gap:30px;
  }
  display:block;
  margin-top:30px;
  ${theme.breakpoints.up("lg")} {
    display:none;
  }
  button {
   width:158px;
   font-weight:600;
  }
`

const FilterCTA = styled.div`
  display:block;
  ${theme.breakpoints.up("lg")} {
    display:none;
  }
  button {
    width:100%;
    font-weight:600;
  }
  svg {
    margin-right:8px;
  }
`

const rangeFilterDefaultPropType = [];
const rangeFilterDefaultPropSleeps = [];
const rangeFilterDefaultPropMustHave = [];
const rangeFilterDefaultPropLength = [];
const rangeFilterDefaultPropWidth = [];
const rangeFilterDefaultPropHeight = [];
const rangeFilterDefaultPropTareWeight = [];
const rangeFilterDefaultPropOnChange = () => {};
const rangeFilterDefaultPropOnClearFilter = () => {};

const RangeFilter = (props) => {
  props = {
    ...props,
    type: typeof props.type === "undefined" ? rangeFilterDefaultPropType : props.type,
    sleeps: typeof props.sleeps === "undefined" ? rangeFilterDefaultPropSleeps : props.sleeps,
    mustHave: typeof props.mustHave === "undefined" ? rangeFilterDefaultPropMustHave : props.mustHave,
    length: typeof props.length === "undefined" ? rangeFilterDefaultPropLength : props.length,
    width: typeof props.width === "undefined" ? rangeFilterDefaultPropWidth : props.width,
    height: typeof props.height === "undefined" ? rangeFilterDefaultPropHeight : props.height,
    tareWeight: typeof props.tareWeight === "undefined" ? rangeFilterDefaultPropTareWeight : props.tareWeight,
    onChange: typeof props.onChange === "undefined" ? rangeFilterDefaultPropOnChange : props.onChange,
    onClearFilter: typeof props.onClearFilter === "undefined" ? rangeFilterDefaultPropOnClearFilter : props.onClearFilter,
    numberOfModels: typeof props.numberOfModels === "undefined" ? 0 : props.numberOfModels
  };

  const {     
    type,
    sleeps,
    mustHave, 
    length,
    width,
    height,
    tareWeight,
    onChange,
    onClearFilter,
    filterValues,
    numberOfModels
  } = props

  const desktopView = useMediaQuery(theme.breakpoints.up('lg'));

  const [open, setOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  return (
    <Wrapper>
      <div className={openModal ? 'modal-container show' : 'modal-container' }>
        <Container>
          <CloseModal>
            <ReactSVG src={close} onClick={() => setOpenModal(!openModal)} />
          </CloseModal>
          <Box px={2}>       
           <Grid container spacing={0} direction={desktopView ? 'row' : 'column'} wrap="nowrap" justifyContent={'space-between'} align={desktopView ? 'center' : 'flex-start'} className='grid-selector'>
              <Grid>
                <Text variant='h6' colour='charcoal' uppercase='true'>Type</Text>
                {type && type.map((item, index) => {
                  return (
                    <SelectItem key={item.value} checked={filterValues['type'] && filterValues['type'].toLowerCase() === item.value.toLowerCase() ? true : false}>
                      <ButtonBase>
                        <Checkbox                         
                          name={item.value}
                          label={item.text}
                          onChange={() => onChange('type', item)} 
                        />
                      </ButtonBase>
                    </SelectItem>
                  )
                })}
              </Grid>
              <Grid>
                <Text variant='h6' colour='charcoal' uppercase='true'>Sleeps</Text>
                {sleeps && sleeps.map((item, index) => {
                  return (
                    <SelectItem key={item.value} checked={filterValues['sleeps'] && filterValues['sleeps'] === item.value ? true : false}>
                      <ButtonBase >
                        <Checkbox                         
                          name={item.value}
                          label={item.text}
                          onChange={() => onChange('sleeps', item)} 
                        />
                      </ButtonBase>
                    </SelectItem>
                  )
                })}
              </Grid>
              <Grid>
                <Text variant='h6' colour='charcoal' uppercase='true'>Must Have</Text>
                {mustHave && mustHave.map((item, index) => {
                  return (
                    <SelectItem key={item.value} checked={filterValues['mustHave'] && filterValues['mustHave'].indexOf(item.value.toLowerCase()) !== -1 ? true : false}>
                      <ButtonBase >
                        <Checkbox                         
                          name={item.value}
                          label={item.text}
                          onChange={() => onChange('mustHave', item)} 
                        />
                      </ButtonBase>
                    </SelectItem>
                  )
                })}
              </Grid>
              <Grid className='available-text-container'>
                <AvailableText>
                  <span>{numberOfModels}</span> Available Models
                </AvailableText>
              </Grid>
           </Grid>
           <Grid container spacing={0} direction={desktopView ? 'row' : 'column'} wrap="wrap" justifyContent={'flex-start'} align={'flex-start'} className={open ? 'grid-selector grid-selector--2' : 'grid-selector grid-selector--2 hidden'}>
            <Grid>
              <Text variant='h6' colour='charcoal' uppercase='true'>Length</Text>
              {length && 
                <DropdownRangeContainer>
                  <Dropdown 
                    label="Length"
                    value={'Length'}
                    options={length}
                    value={filterValues['length']}
                    onChange={(e) => onChange('length', e)}
                  />
                </DropdownRangeContainer>
              }
            </Grid>
            <Grid>
              <Text variant='h6' colour='charcoal' uppercase='true'>Width</Text>
              {width && 
                <DropdownRangeContainer>
                  <Dropdown 
                    label="Width"
                    value={'Width'}
                    options={width}
                    value={filterValues['width']}
                    onChange={(e) => onChange('width', e)}
                  />
                </DropdownRangeContainer>
              }
            </Grid>
            <Grid>
              <Text variant='h6' colour='charcoal' uppercase='true'>Height</Text>
              {height && 
                <DropdownRangeContainer>
                  <Dropdown 
                    label="Height"
                    value={'Height'}
                    options={height}
                    value={filterValues['height']}
                    onChange={(e) => onChange('height', e)}
                  />
                </DropdownRangeContainer>
              }
            </Grid>
            <Grid>
              <Text variant='h6' colour='charcoal' uppercase='true'>Tare Weight</Text>
              {tareWeight && 
                <DropdownRangeContainer>
                  <Dropdown 
                    label="Tare Weight"
                    value={'Tare Weight'}
                    options={tareWeight}
                    value={filterValues['tareWeight']}
                    onChange={(e) => onChange('tareWeight', e)}
                  />
                </DropdownRangeContainer>
              }
            </Grid>
           </Grid>
           <ControllerDesktop>
            <Grid container spacing={0} direction={'row'} wrap="wrap" justifyContent={'flex-start'} align={'flex-start'}>
              <Grid>
                <a href="javascript:;" className={open ? 'is-active' : ''} onClick={() => setOpen(!open)}>{!open ? `Show` : `Hide`} Advanced Filters <ReactSVG src={chevronDown} /></a>
              </Grid>
              <Grid>
                <a href="javascript:;" onClick={onClearFilter}>CLEAR Filters</a>
              </Grid>
             </Grid>
           </ControllerDesktop>

           <ControllerMobile>
            <Grid container spacing={0} direction={'row'} wrap="wrap" justifyContent={'flex-start'} align={'flex-start'} className='gird-ctas'>
              <Grid>
                <Cta onClick={() => setOpenModal(false)}>APPLY</Cta>
              </Grid>
              <Grid>
               <Cta primary outline onClick={() => {
                 onClearFilter();
               }}>RESET</Cta> 
              </Grid>
             </Grid>
           </ControllerMobile>       
          </Box>
        </Container>
      </div>
      <FilterCTA>
        <Box px={2}>
          <Cta primary outline onClick={() => setOpenModal(!openModal)}><ReactSVG src={filter} /> FILTER RANGE</Cta> 
        </Box>
      </FilterCTA>
    </Wrapper>
  );
}

RangeFilter.propTypes = {
  type: propTypes.array,
  sleeps: propTypes.array,
  mustHave: propTypes.array,
  length: propTypes.array,
  width: propTypes.array,
  height: propTypes.array,
  tareWeight: propTypes.array,
  numberOfModels: propTypes.number
}

export default RangeFilter